import create from "zustand";
export var useNotificationListStore = create(function (set) { return ({
    notificationList: [],
    setNotificationList: function (items) {
        return set(function () { return ({
            notificationList: items,
        }); });
    },
    removeNotification: function (id) {
        return set(function (state) { return ({
            notificationList: state.notificationList.filter(function (item) { return item.id !== id; }),
        }); });
    },
}); });
